import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './schema';

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

/** CSRF (ADR-0003): API принимает мутации только с заголовком X-Requested-With. */
export const csrfHeader: Middleware = {
  onRequest({ request }) {
    if (!SAFE_METHODS.has(request.method)) {
      request.headers.set('X-Requested-With', 'XMLHttpRequest');
    }
    return request;
  },
};

/**
 * Клиент API, сгенерированный из OpenAPI (AGENTS.md §17): руками запросы не пишем.
 * Тот же origin, что у фронта: cookie сессии уходит автоматически.
 */
export const api = createClient<paths>({
  // Origin страницы явно: в браузере это то же, что '/', а `Request` вне браузера (тесты)
  // относительный адрес не принимает.
  baseUrl: window.location.origin,
  credentials: 'same-origin',
});
api.use(csrfHeader);
